import { i18nTranslate } from 'src/utils'

const loyaltyRewards = () => {
  return [
    {
      key: 'earned',
      localeText: i18nTranslate('loyalty.earned', 'Earned Rewards'),
    },
    {
      key: 'approved',
      localeText: i18nTranslate('loyalty.approved', 'Approved Rewards'),
    },
    {
      key: 'canceled',
      localeText: i18nTranslate('loyalty.canceled', 'Canceled Rewards'),
    },
    {
      key: 'expired',
      localeText: i18nTranslate('loyalty.expired', 'Expired Rewards'),
    },
    {
      key: 'forfeited',
      localeText: i18nTranslate('loyalty.forfeited', 'Forfeited Rewards'),
    },
    {
      key: 'redeemed',
      localeText: i18nTranslate('loyalty.redeemed', 'Redeemed Rewards'),
    },
    {
      key: 'reverseRedeemed',
      localeText: i18nTranslate(
        'loyalty.reverseRedeemed',
        'Reverse Redeemed Rewards'
      ),
    },
    {
      key: 'openToRedeem',
      localeText: i18nTranslate(
        'loyalty.openToRedeem',
        'Rewards Open to Redeem'
      ),
    },
  ]
}

const locales = {
  points: i18nTranslate('loyalty.points', 'Points'),
  storecredit: i18nTranslate('loyalty.storeCredit', 'Store Credit'),
}

export { loyaltyRewards, locales }
